import { render } from "./NotesDisplay.vue?vue&type=template&id=11a23675"
import script from "./NotesDisplay.vue?vue&type=script&lang=js"
export * from "./NotesDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__